module.exports = __webpack_public_path__ + "static/media/vendas.947527b5.svg";